import { useEffect } from "react";
import { useAppDispatch } from "@/store";
import { fetchStats, fetchScrapers } from "@/store/scrapersSlice";
import { fetchRecentActivity } from "@/store/historySlice";

const RECENT_ACTIVITY_LIMIT = 10;

/** Loads dashboard stats, scraper list, and recent history once on mount. */
export function useDashboardBootstrap() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchStats());
    dispatch(fetchScrapers());
    dispatch(fetchRecentActivity(RECENT_ACTIVITY_LIMIT));
  }, [dispatch]);
}
